import { Newspaper, Tags, Radar, FileText, History, Gauge } from "lucide-react";
import ProductPageLayout from "@/components/ProductPageLayout";

export default function NewsIntelligence() {
  return (
    <ProductPageLayout
      meta={{
        title: "News Intelligence — AI-Powered Financial News Analytics | Adviserz",
        description:
          "AI-powered financial news intelligence: aggregation, sentiment analysis, entity extraction, market-event detection and AI-assisted summarisation. Informational only.",
        canonical: "https://adviserz.in/news-intelligence",
      }}
      overline="Platform · News Intelligence"
      title="AI-powered financial"
      accent="news intelligence."
      lede="Markets react to information faster than people can read it. Our news intelligence engine aggregates, classifies and summarises financial news and market events so users can understand market-moving information and emerging themes. It explains what is being reported — it does not tell anyone what to do about it."
      capabilities={[
        { icon: Newspaper, t: "News Aggregation", d: "Continuous collection of financial news, exchange filings and market commentary into a single structured stream." },
        { icon: Gauge, t: "Sentiment Analysis", d: "Model-based classification of tone and polarity at article, entity and theme level, with confidence reported." },
        { icon: Tags, t: "Entity Extraction", d: "Identification of companies, sectors, people and instruments mentioned, enabling entity-level news analytics." },
        { icon: Radar, t: "Market-Event Detection", d: "Detection and classification of event types — results, corporate actions, policy and macro releases, and regulatory updates." },
        { icon: FileText, t: "AI-Assisted Summarisation", d: "Concise summaries of long documents and news clusters, clearly labelled as AI-generated and subject to error." },
        { icon: History, t: "Historical News Analysis", d: "Searchable historical archive to study how information flow and themes evolved around past market periods." },
      ]}
      approach={[
        { t: "Ingest", d: "News and filings are collected and de-duplicated across sources." },
        { t: "Structure", d: "Text is classified, tagged with entities and event types, and linked to relevant instruments." },
        { t: "Summarise", d: "Language models generate summaries and theme clusters, with source links preserved for verification." },
        { t: "Contextualise", d: "Outputs are presented alongside historical news activity so users can judge significance themselves." },
      ]}
      notWhatWeDo={[
        "AI does not recommend securities to buy or sell",
        "No claim of complete or real-time news coverage",
        "Sentiment scores are measurements, not advice",
        "Summaries may contain errors or omissions",
        "No representation of accuracy of third-party sources",
        "Always verify against original source documents",
      ]}
    />
  );
}
